import { makeEntityScaffold } from '@classpass/saga-tools';
import { transformKeysToCamelCase } from 'helpers/core';
import URLS from 'constants/urls';

const handler = ({ httpClient }, { venueId, weeksCount = 1, scheduleId = null }) => {
  const endpoint = URLS.home.excessInventory(venueId, weeksCount, scheduleId);
  return httpClient.get(endpoint, { ignoreInternalError: true }).then(({ data }) => transformKeysToCamelCase(data));
};

export default makeEntityScaffold('SAGA.API.EXCESS_INVENTORY', handler, {
  defaultKey: (client, { venueId, weeksCount, scheduleId }) => {
    const key = [venueId];
    if (scheduleId) {
      key.push(scheduleId);
    }
    key.push(weeksCount);
    return key.join('-');
  },
});
